import { createStore, combineReducers } from 'redux';
import categoriesToggler from '../reducers/categoriesToggler';
import simpleToggler from '../reducers/simpleToggler';
import numbersDucer from '../reducers/numbersDucer';
import { composeWithDevTools } from 'redux-devtools-extension';

const reducer = combineReducers({
    categoriesToggler,
    simpleToggler,
    numbersDucer
})

const store = createStore(reducer, composeWithDevTools())

export default store